import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePackageTransferMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  transferId: GraphQLTypes.Scalars['String'];
}>;


export type DeletePackageTransferMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'deletePackageTransfer'>
);


export const DeletePackageTransferDocument = /*#__PURE__*/ gql`
    mutation deletePackageTransfer($packageId: String!, $transferId: String!) {
  deletePackageTransfer(packageId: $packageId, transferId: $transferId)
}
    `;

/**
 * __useDeletePackageTransferMutation__
 *
 * To run a mutation, you first call `useDeletePackageTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageTransferMutation, { data, loading, error }] = useDeletePackageTransferMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      transferId: // value for 'transferId'
 *   },
 * });
 */
export function useDeletePackageTransferMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackageTransferMutationResult, DeletePackageTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackageTransferMutationResult, DeletePackageTransferMutationVariables>(DeletePackageTransferDocument, options);
      }
export type DeletePackageTransferMutationHookResult = ReturnType<typeof useDeletePackageTransferMutation>;